export enum ModalTypeValue {
  LOGIN = "LOGIN",
  REGISTER = "REGISTER",
  FORGET_PASSWORD = "FORGET_PASSWORD",
  ANNOUNCEMENT = "Announcement",
  INFORMATION = "INFORMATION",
  MOBILE_NEWS = "MOBILE_NEWS",
  NEWS = "NEWS",
  NOTI = "NOTI",
  BANK = "Bank",
  VIP = "VIP",
  MOBILE_VIP = "MOBILE_VIP",
  CLOSE = "",
}
export enum ModalType {
  CLOSE_NOTI = "",
  NOTI = "NOTI",
  NOTI_MOBILE = "NOTI_MOBILE",
  CLOSE_NOTI_MOBILE = "",
  CLOSE_FORGOT = "",
  FORGOT = "FORGOT",
}
